import {
    faPlug,
    faCircleCheck,
    faPlugCircleCheck ,
    faTriangleExclamation,
    faBolt,
    faHourglassHalf,
    faCheckDouble,
    faLock,
    faBan,
    faClock,
    faPauseCircle,
    faCircleXmark
} from "@fortawesome/pro-regular-svg-icons";
import {
    getStatusHexColor as getBrandStatusHexColor,
    getStatusChipStyleVars,
    getLogTypeChipStyleVars,
    getStatusColorStyle,
    getStatusStripeStyle,
} from "../theme/gitoColors";

export const StatusText = {
    AVAILABLE: "Available",
    PREPARING: "Preparing",
    OCCUPIED: "Occupied",
    CHARGING: "Charging",
    EVCONNECTED: "EV Connected",
    IDLE: "Idle",
    FINISHING: "Finishing",
    INOPERATIVE: "Inoperative",
    UNAVAILABLE: "Unavailable",
    RESERVED: "Reserved",
    PENDING: "Pending",
    FAULTED: "Faulted",
    SUSPENDEDEV: "Suspended EV",
    SUSPENDEDEVSE: "Suspended EVSE",
    ALERTING: "Alerting",
    DELTA: "Delta",
    PERIODIC: "Periodic",

    ONLINE: "Online",
    OFFLINE: "Offline",

    SUCCESS: "Success",
    INFO: "Info",
    WARNING: "Warning",
    ERROR: "Error",

    ACCEPTED: "Accepted",
    ACTIVE: "Active",
    FINISHED: "Finished",
    REJECTED: "Rejected",
    EXPIRED: "Expired",
    INVALID: "Invalid",
    CONCURRENTTX: "ConcurrentTx",

    LIVE: "LIVE",
    DISCONNECTED: "DISCONNECTED",

    POINT: "Point",
    CONNECTOR: "Connector",

    DEFAULT: "—",
};

export const getStatusLabel = (status, t) => {
    if (status == null || status === "") {
        return t ? t("status.DEFAULT") : StatusText.DEFAULT;
    }

    const key = String(status).toUpperCase().replace(/[\s-]+/g, "");
    if (t) {
        return t(`status.${key}`, { defaultValue: StatusText[key] || String(status) });
    }

    return StatusText[key] || String(status);
};

export const getStatusLabelWithMaintenance = (status, maintenanceMode, t) => {
    if (maintenanceMode) {
        if (t) {
            return t("chargeMonitor.unavailableManuallySet", {
                defaultValue: "Unavailable - Manually set",
            });
        }

        return "Unavailable - Manually set";
    }

    return getStatusLabel(status, t);
};

export const StatusIconByKey = {
    AVAILABLE: faPlugCircleCheck,
    PREPARING: faHourglassHalf,
    OCCUPIED: faHourglassHalf,
    CHARGING: faBolt,
    EVCONNECTED: faPlug,
    IDLE: faPauseCircle,
    FINISHING: faCheckDouble,
    INOPERATIVE: faCircleXmark,
    UNAVAILABLE: faBan,
    RESERVED: faLock,
    PENDING: faClock,
    FAULTED: faTriangleExclamation,
    SUSPENDEDEV: faPauseCircle,
    SUSPENDEDEVSE: faPauseCircle,
    ALERTING: faTriangleExclamation,
    DELTA: faBolt,
    PERIODIC: faClock,

    ONLINE: faCircleCheck,
    OFFLINE: faCircleXmark,

    SUCCESS: faCircleCheck,
    INFO: faClock,
    WARNING: faTriangleExclamation,
    ERROR: faCircleXmark,

    LIVE: faCircleCheck,
    DISCONNECTED: faCircleXmark,

    POINT: faPlug,
    CONNECTOR: faPlug,

    DEFAULT: faPlug
};

export const getStatusClasses = (_status = "", isBadge = true) => {
    return isBadge ? "badge" : "chip";
};

export const getFilterChipClasses = (_status = "", active = false) => {
    return active ? "chip chip--active" : "chip";
};

export const getStatusStyleVars = getStatusChipStyleVars;
export const getLogTypeStyleVars = getLogTypeChipStyleVars;
export const getStatusHexColor = getBrandStatusHexColor;
export const getStatusBadgeClass = getStatusClasses;

export {
    getStatusChipStyleVars,
    getLogTypeChipStyleVars,
    getStatusColorStyle,
    getStatusStripeStyle,
};
